import React, { useState } from 'react';
import { api } from '../utils/api';

function Feedback() {
  const [orderData, setOrderData] = useState({ tracking_id: '', customer_name: '', customer_phone: '' });
  const [products, setProducts] = useState([]);
  const [feedbacks, setFeedbacks] = useState({});
  const [showProducts, setShowProducts] = useState(false);

  const handleVerifyOrder = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${api.baseURL}/order_products.php?tracking_id=${orderData.tracking_id}&customer_name=${encodeURIComponent(orderData.customer_name)}&customer_phone=${encodeURIComponent(orderData.customer_phone)}`);
      const result = await response.json();
      
      if (result.success) {
        setProducts(result.data);
        setShowProducts(true);
        const initialFeedbacks = {};
        result.data.forEach(product => {
          initialFeedbacks[product.id] = {
            rating: product.rating || 0,
            comment: product.comment || '',
            submitted: !!product.feedback_id
          };
        });
        setFeedbacks(initialFeedbacks);
      } else {
        alert(result.message);
      }
    } catch (error) {
      alert('Failed to verify order');
    }
  };

  const handleSubmitFeedback = async (productId) => {
    const feedback = feedbacks[productId];
    if (!feedback.rating || feedback.rating === 0) {
      alert('Please select a rating');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('product_id', parseInt(productId));
      formData.append('tracking_id', orderData.tracking_id);
      formData.append('customer_name', orderData.customer_name);
      formData.append('customer_phone', orderData.customer_phone);
      formData.append('rating', parseInt(feedback.rating));
      formData.append('comment', feedback.comment || '');
      if (feedback.image) {
        formData.append('image', feedback.image);
      }
      
      console.log('Sending feedback:', productId);
      
      const response = await fetch(`${api.baseURL}/feedback.php`, {
        method: 'POST',
        body: formData
      });
      const result = await response.json();
      
      console.log('Response:', result);
      
      if (result.success) {
        alert('Feedback submitted successfully!');
        setFeedbacks(prev => ({
          ...prev,
          [productId]: { ...prev[productId], submitted: true }
        }));
      } else {
        alert(result.message || 'Failed to submit feedback');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Failed to submit feedback: ' + error.message);
    }
  };

  const updateFeedback = (productId, field, value) => {
    setFeedbacks(prev => ({
      ...prev,
      [productId]: { ...prev[productId], [field]: value }
    }));
  };

  return (
    <div className="container" style={{padding: '40px 20px', maxWidth: '900px', margin: '0 auto'}}>
      <h1 style={{textAlign: 'center', marginBottom: '30px', color: '#333'}}>Product Feedback</h1>

      {!showProducts ? (
        <div style={{background: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)'}}>
          <h2 style={{marginBottom: '20px'}}>Enter Order Details</h2>
          <form onSubmit={handleVerifyOrder}>
            <div style={{display: 'grid', gap: '15px'}}>
              <input
                type="text"
                placeholder="Tracking ID (FE-XXXX)"
                value={orderData.tracking_id}
                onChange={(e) => setOrderData({...orderData, tracking_id: e.target.value})}
                required
                style={{padding: '12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '16px'}}
              />
              <input
                type="text"
                placeholder="Your Name"
                value={orderData.customer_name}
                onChange={(e) => setOrderData({...orderData, customer_name: e.target.value})}
                required
                style={{padding: '12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '16px'}}
              />
              <input
                type="tel"
                placeholder="Mobile Number"
                value={orderData.customer_phone}
                onChange={(e) => setOrderData({...orderData, customer_phone: e.target.value})}
                required
                style={{padding: '12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '16px'}}
              />
              <button type="submit" style={{padding: '12px', background: '#2196f3', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: '600', cursor: 'pointer'}}>Verify Order</button>
            </div>
          </form>
        </div>
      ) : (
        <div>
          <div style={{background: '#f0f8ff', padding: '15px', borderRadius: '8px', marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            <div>
              <strong>Order {orderData.tracking_id}</strong> - {orderData.customer_name}
            </div>
            <button onClick={() => { setShowProducts(false); setProducts([]); }} style={{padding: '8px 16px', background: '#666', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer'}}>Change Order</button>
          </div>

          <h2 style={{marginBottom: '20px'}}>Your Products</h2>
          
          {products.map((product) => (
            <div key={product.id} style={{background: '#fff', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', marginBottom: '20px'}}>
              <div style={{display: 'flex', gap: '20px', marginBottom: '15px'}}>
                <img src={product.image || 'https://placehold.co/100x100'} alt={product.name} style={{width: '100px', height: '100px', objectFit: 'cover', borderRadius: '8px'}} />
                <div style={{flex: 1}}>
                  <h3 style={{margin: '0 0 8px 0'}}>{product.name}</h3>
                  <p style={{color: '#666', margin: '0'}}>Quantity: {product.quantity} | Price: Rs {product.order_price}</p>
                </div>
              </div>

              {feedbacks[product.id]?.submitted ? (
                <div style={{background: '#e8f5e9', padding: '15px', borderRadius: '4px', border: '1px solid #4caf50'}}>
                  <strong style={{color: '#4caf50'}}>✓ Feedback Submitted</strong>
                  <div style={{marginTop: '8px', color: '#ffc107', fontSize: '20px'}}>{'★'.repeat(feedbacks[product.id].rating)}{'☆'.repeat(5 - feedbacks[product.id].rating)}</div>
                  {feedbacks[product.id].comment && <p style={{margin: '8px 0 0 0', color: '#666'}}>{feedbacks[product.id].comment}</p>}
                  {feedbacks[product.id].image && <img src={feedbacks[product.id].image} alt="Feedback" style={{marginTop: '10px', maxWidth: '200px', borderRadius: '8px'}} />}
                </div>
              ) : (
                <div>
                  <div style={{marginBottom: '12px'}}>
                    <label style={{display: 'block', marginBottom: '8px', fontWeight: '600'}}>Rating:</label>
                    <div style={{display: 'flex', gap: '8px', fontSize: '32px'}}>
                      {[1, 2, 3, 4, 5].map((star) => (
                        <span
                          key={star}
                          onClick={() => updateFeedback(product.id, 'rating', star)}
                          style={{cursor: 'pointer', color: star <= (feedbacks[product.id]?.rating || 0) ? '#ffc107' : '#ddd'}}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                  </div>
                  <div style={{marginBottom: '12px'}}>
                    <label style={{display: 'block', marginBottom: '8px', fontWeight: '600'}}>Comment (optional):</label>
                    <textarea
                      value={feedbacks[product.id]?.comment || ''}
                      onChange={(e) => updateFeedback(product.id, 'comment', e.target.value)}
                      rows="3"
                      style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px'}}
                      placeholder="Share your experience with this product..."
                    />
                  </div>
                  <div style={{marginBottom: '12px'}}>
                    <label style={{display: 'block', marginBottom: '8px', fontWeight: '600'}}>Upload Image (optional):</label>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => updateFeedback(product.id, 'image', e.target.files[0])}
                      style={{width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '4px'}}
                    />
                  </div>
                  <button
                    onClick={() => handleSubmitFeedback(product.id)}
                    disabled={!feedbacks[product.id]?.rating || feedbacks[product.id]?.rating === 0}
                    style={{padding: '10px 20px', background: (!feedbacks[product.id]?.rating || feedbacks[product.id]?.rating === 0) ? '#ccc' : '#4caf50', color: '#fff', border: 'none', borderRadius: '4px', cursor: (!feedbacks[product.id]?.rating || feedbacks[product.id]?.rating === 0) ? 'not-allowed' : 'pointer', fontWeight: '600'}}
                  >
                    Submit Feedback
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Feedback;
